/**
 * CSTM Header Drawer JavaScript
 * Custom Header with Enterprise Search Engine v3.0
 * 
 * Features:
 * - Phonetic Search (Kölner Phonetik)
 * - N-Gram Matching for partial words
 * - Dynamic Shop Dictionary
 * - Intent Detection (price, size, new)
 * - German Stemming
 * - Enhanced SKU matching
 * - Smart "Did you mean?" suggestions
 * 
 * Extracted from cstm-header-drawer-menu.liquid for Shopify's 256KB file limit
 * All Liquid variables are passed via data-attributes on the header element
 */

(function() {
  function initCstmHeader(sectionId) {
    const header = document.getElementById(sectionId);
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';
    
    // Read config from data-attributes (set in Liquid)
    const config = header.dataset.config ? JSON.parse(header.dataset.config) : {};
    const SECTION_ID = sectionId;
    
    // ========================================
    // DRAWER FUNCTIONALITY
    // ========================================
    if (!header.querySelector('biwo-menu-drawer')) {
    const drawer = header.querySelector('[data-drawer]');
    const overlay = header.querySelector('[data-drawer-overlay]');
    const closeBtn = header.querySelector('[data-drawer-close]');
    const mobileToggle = header.querySelector('[data-mobile-toggle]');
    const navTriggers = header.querySelectorAll('[data-drawer-trigger]');
    const tabs = header.querySelectorAll('[data-drawer-tab]');
    const panelGroups = header.querySelectorAll('[data-panel-group]');
    
    let isOpen = false;
    let activeGroup = null;
    
    function openDrawer(groupHandle) {
      isOpen = true;
      header.classList.add('cdh--drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setActiveGroup(groupHandle);
      navTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', trigger.dataset.drawerTrigger === groupHandle ? 'true' : 'false');
      });
    }
    
    function closeDrawer() {
      isOpen = false;
      header.classList.remove('cdh--drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      navTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      setTimeout(() => { resetPanels(); }, 300);
    }
    
    function setActiveGroup(handle) {
      activeGroup = handle;
      panelGroups.forEach(group => {
        group.setAttribute('aria-hidden', group.dataset.panelGroup !== handle);
      });
      tabs.forEach(tab => {
        tab.setAttribute('aria-selected', tab.dataset.drawerTab === handle);
      });
      const activeGroupEl = header.querySelector(`[data-panel-group="${handle}"]`);
      if (activeGroupEl) resetPanelsInGroup(activeGroupEl);
      hideFeaturedOnDeepNavigation(1);
    }
    
    function resetPanels() {
      panelGroups.forEach(group => { resetPanelsInGroup(group); });
      hideFeaturedOnDeepNavigation(1);
    }
    
    function resetPanelsInGroup(group) {
      const panel2 = group.querySelector('[data-panel="2"]');
      const panel3 = group.querySelector('[data-panel="3"]');
      if (panel2) panel2.setAttribute('aria-hidden', 'true');
      if (panel3) panel3.setAttribute('aria-hidden', 'true');
      group.querySelectorAll('[data-panel-content]').forEach(content => {
        content.setAttribute('aria-hidden', 'true');
      });
      group.querySelectorAll('[data-active]').forEach(el => {
        el.removeAttribute('data-active');
      });
    }
    
    // ========================================
    // PANEL NAVIGATION HELPERS
    // ========================================
    function hideFeaturedOnDeepNavigation(level) {
      const featured = header.querySelector('.cdh-drawer-featured');
      if (featured) {
        featured.style.display = level > 1 ? 'none' : '';
      }
    }
    
    function showPanel(group, panelNum, targetHandle, triggerEl) {
      const panel = group.querySelector(`[data-panel="${panelNum}"]`);
      const content = panel?.querySelector(`[data-panel-content="${targetHandle}"]`);
      if (!panel || !content) return;
      panel.setAttribute('aria-hidden', 'false');
      panel.querySelectorAll('[data-panel-content]').forEach(c => {
        c.setAttribute('aria-hidden', c.dataset.panelContent !== targetHandle);
      });
      const prevPanel = group.querySelector(`[data-panel="${panelNum - 1}"]`);
      if (prevPanel) {
        prevPanel.querySelectorAll('[data-active]').forEach(el => el.removeAttribute('data-active'));
        if (triggerEl) triggerEl.setAttribute('data-active', 'true');
      }
      hideFeaturedOnDeepNavigation(panelNum);
    }
    
    function goBack(group, toPanelNum, backTarget) {
      for (let i = 3; i > toPanelNum; i--) {
        const panel = group.querySelector(`[data-panel="${i}"]`);
        if (panel) panel.setAttribute('aria-hidden', 'true');
      }
      if (toPanelNum === 2 && backTarget) {
        const panel2 = group.querySelector('[data-panel="2"]');
        if (panel2) {
          panel2.querySelectorAll('[data-panel-content]').forEach(c => {
            c.setAttribute('aria-hidden', c.dataset.panelContent !== backTarget);
          });
        }
      }
      hideFeaturedOnDeepNavigation(toPanelNum);
    }
    
    // Event Listeners
    navTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const handle = trigger.dataset.drawerTrigger;
        if (isOpen && activeGroup === handle) closeDrawer();
        else openDrawer(handle);
      });
    });
    
    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        if (isOpen) closeDrawer();
        else {
          const firstTrigger = header.querySelector('[data-drawer-trigger]');
          if (firstTrigger) openDrawer(firstTrigger.dataset.drawerTrigger);
        }
      });
    }
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => { setActiveGroup(tab.dataset.drawerTab); });
    });
    
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    
    header.querySelectorAll('[data-panel-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const group = trigger.closest('[data-panel-group]');
        const panelNum = parseInt(trigger.dataset.panelTrigger);
        const targetHandle = trigger.dataset.target;
        showPanel(group, panelNum, targetHandle, trigger);
      });
    });
    
    header.querySelectorAll('[data-panel-back]').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-panel-group]');
        const toPanelNum = parseInt(btn.dataset.panelBack);
        const backTarget = btn.dataset.backTarget;
        goBack(group, toPanelNum, backTarget);
      });
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });
    
    }

  }
  // ========================================
  // INITIALIZATION
  // ========================================
  
  // Global initialization function
  window.initCstmHeaderDrawer = function(sectionId) {
    initCstmHeader(sectionId);
  };
  
  // Auto-initialize all headers on DOM ready
  function autoInit() {
    document.querySelectorAll('[data-cstm-header-drawer]').forEach(header => {
      initCstmHeader(header.id);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }
  
  // Theme Editor support
  document.addEventListener('shopify:section:load', (e) => {
    const header = e.target.querySelector('[data-cstm-header-drawer]');
    if (header) {
      header.dataset.initialized = 'false';
      initCstmHeader(header.id);
    }
  });

  // ========================================
  // WISHLIST COUNTER IN HEADER
  // ========================================
  function updateWishlistCounter() {
    try {
      const list = JSON.parse(localStorage.getItem('cpc_wishlist') || '[]');
      const count = list.length;
      document.querySelectorAll('[data-wishlist-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    } catch(e) {}
  }

  // Update on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCounter);
  } else {
    updateWishlistCounter();
  }

  // Update when wishlist changes
  document.addEventListener('wishlist:updated', updateWishlistCounter);
  // Also listen for storage changes (other tabs)
  window.addEventListener('storage', (e) => {
    if (e.key === 'cpc_wishlist') updateWishlistCounter();
  });
})();
